import React from 'react';
import { Layout } from 'antd';
import Header from './header/header';
import Footer from './footer/footer';

const { Content } = Layout;

const MainLayout = ({ children }) => {
    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Header />
            <Content style={{
                padding: '24px 0',
                flex: 1
            }}>
                <div className="container">
                    {children} {/* ← Вот сюда попадут AppRoutes! */}
                </div>
            </Content>
            <Footer />
        </Layout>
    );
};

export default MainLayout;